const isOnline = /(market|cloud|qifu)\.baidu\.com/.test(window.location.hostname);
const host = isOnline ? 'https://console.bce.baidu.com' : 'https://qasandbox.bcetest.baidu.com';
const currentHost = `${window.location.href.split('#')[0]}`;

const link = isOnline ? {
    displayName: 'https://bce.baidu.com',
    login: 'https://login.bce.baidu.com/?redirect='
        + encodeURIComponent(`${window.location.origin}${window.location.pathname}`) + window.location.hash,
    mobileHeaderScriptSrc: 'https://bce.bdstatic.com/fe-static/baidu/bce-portal/portal-common/load.online.js',
    backParkUrl: '/product/cbs#/park',
    successUrl: `${currentHost}#/order/pay/success`,
    frontUrl: currentHost,
    orderListUrl: 'https://console.bce.baidu.com/billing/#/order/list',
    host
} : {
    displayName: 'https://bcetest.baidu.com',
    login: 'https://login.bcetest.baidu.com/?redirect='
        + encodeURIComponent(`${window.location.origin}${window.location.pathname}`) + window.location.hash,
    mobileHeaderScriptSrc: 'https://bce.bdstatic.com/fe-static/baidu/bce-portal/portal-common/load.sandbox.js',
    backParkUrl: '/product/cbs#/park',
    successUrl: `${currentHost}#/order/pay/success`,
    frontUrl: currentHost,
    orderListUrl: 'https://qasandbox.bcetest.baidu.com/billing/#/order/list',
    host
};

export default link;
